import en from './spendBenefitsStrings.en';

export default {
  en,
};
